import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Era } from "@app/models/date.model";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class EraService {
    constructor(private httpClient: HttpClient) { }
    private eras: Era[] = [];
    
    async load(): Promise<void> {
        return firstValueFrom(
            this.httpClient.get<Era[]>('/assets/jp-eras.json')
        ).then(data => {
            this.eras = data ?? [];
        });
    }

    getEras(): Era[] {
        return this.eras;
    }
}